import { TimePickerTranslations } from './types';

export const defaultTranslations: TimePickerTranslations = {
  placeholder: 'Select time',
};
